/** @format */

import template from './gb-edit-thermometer-widget.html';
import './gb-edit-thermometer-widget.scss';

export const GbEditThermometerWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditThermometerWidgetComponent {
        constructor(LoadingHelper, $ccLoading, $gbAuctionImage, $log, $gbTask, $ccToast, $q) {
            'ngInject';

            this.$gbAuctionImage = $gbAuctionImage;
            this.$log = $log;
            this.$gbTask = $gbTask;
            this.$ccToast = $ccToast;
            this.$q = $q;

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        getWidget() {
            return this.widget;
        }

        hasImage() {
            return !!(this.widget && this.widget.custom_image);
        }

        getAuctionImage() {
            if (this.hasImage()) {
                return this.widget.custom_image;
            }
        }

        removeImage() {
            let image = this.widget.custom_image;

            if (image) {
                this.widget.custom_image = null;

                return this.gbEditTools.saveWidget().then(() => {
                    return this.deleteImage(image);
                });
            } else {
                return this.$q.resolve();
            }
        }

        reselectImage() {
            let oldImage = this.widget.custom_image;

            return this.uploadImage().then(() => this.deleteImage(oldImage));
        }

        uploadImage() {
            if (!!this.imageToUpload) {
                let loader = this.loadingHelper.push('UPLOADING_IMAGE');

                return this.$gbAuctionImage
                    .uploadImage(this.imageToUpload, {
                        url_name: this.gbApp.getAuctionUrl(),
                    })
                    .then((response) => {
                        this.$log.info('Started Upload Task...', response);

                        return this.$gbTask.get({
                            uuid: response.blackboard_uuid,
                        }).$promise;
                    })
                    .then((data) => {
                        this.$log.info('Image Upload Complete!', data);
                        let auctionImage = data.results;

                        this.$gbAuctionImage.cache.push(auctionImage);
                        this.getWidget().custom_image = auctionImage;
                        this.gbEditTools.saveWidget();
                    })
                    .catch((err) => {
                        this.$ccToast.error(err);
                    })
                    .finally(() => {
                        loader();
                    });
            } else {
                return this.$q.reject();
            }
        }

        deleteImage(auctionImage) {
            // No cached image found for uuid, no need to delete
            if (!auctionImage) {
                return this.$q.resolve();
            }

            auctionImage = angular.copy(auctionImage);
            return auctionImage
                .$delete({
                    url_name: this.gbApp.getAuctionUrl(),
                })
                .then((data) => {
                    this.$log.info('Deleted Auction Image', auctionImage, data);
                    this.$gbAuctionImage.cache.remove(auctionImage.uuid);
                });
        }

        $onDestroy() {
            this.loadingWatcher();
        }
    },
};
